<div class="ion-page modal-body">
  <div class="modalInnerWrapper modal-content">
    <div class="modal-body">
      <h4 class="t-h4 mt-4 t-medium" style="text-align: center;">{{'COMMON.LIVE-STREEM' | translate}}</h4>

      <!-- Video.js Player -->
      <div class="video-container">
        <video
          id="video-player"
          class="video-js vjs-default-skin"
          controls
          playsinline
          webkit-playsinline
          [poster]="playerPoster">

          <source
            *ngIf="!videoUrl?.includes('.m3u8')"
            [src]="videoUrl" />

          <source
            *ngIf="videoUrl?.includes('.m3u8')"
            [src]="videoUrl"
            type="application/x-mpegURL" />
        </video>
      </div>
    </div>

    <button (click)="dismiss()" type="link" class="close">
      <span class="icon icon-close"></span>
    </button>
  </div>
</div>
